export interface OrganizationSeo {
  title: string;
  shortName: string;
  description: string;
  keywords: string;
  name: string;
}

export interface OrgMeta {
  key: string;
  seo: OrganizationSeo;
}

export const ORG_META: Record<string, OrgMeta> = {
  LKC: {
    key: "LKC",
    seo: {
      title: "Lori Knapp Choice™ Portal and Provider Directory for Wisconsin Self-Direction",
      shortName: "LKC™",
      description:
        "mySD Hub is the customer portal for Lori Knapp Choice™ allowing service providers to find work and current participants/members to view enrollment and budget information.",
      keywords:
        "Lori Knapp Choice, Lori Knapp Choice portal, mySD Hub, Lori Knapp portal, seeking caregiver work in Wisconsin, looking for caregiver opportunities in Wisconsin, Wisconsin self-direction caregivers, Wisconsin self-direction vendors, Inclusa caregivers, Inclusa vendors, iCare caregivers, iCare vendors, Inclusa Lori Knapp Choice, iCare Lori Knapp Choice, Lori Knapp Choice hub, provider directory, Lori Knapp Choice provider directory",
      name: "Lori Knapp Choice™",
    },
  },
  PAS: {
    key: "PAS",
    seo: {
      title: "PAS Portal and Provider Directory for Michigan Self-Direction",
      shortName: "PAS",
      description:
        "mySD Hub is the customer portal for PAS allowing service providers to find work and current participants/members to view enrollment and budget information.",
      keywords:
        "PAS, PAS Self Direction, PAS Self-Direction, Personal Accounting Services, PAS portal, mySD Hub, PAS mySD Hub, PAS Self Direction Portal, seeking caregiver work in Michigan, seeking caregiver work in Detroit, seeking caregiver work in St. Clair County, looking for caregiver opportunities in Michigan, looking for caregiver opportunities in Detroit, looking for caregiver opportunities in St. Clair County, Michigan self-direction caregivers, Michigan self-direction vendors, Detroit Wayne caregivers, Detroit Wayne vendors, St. Clair County caregivers, St. Clair County vendors, Detroit Wayne PAS, St. Clair County PAS, Detroit Wayne Personal Accounting Services, St. Clair County Personal Accounting Services, PAS hub, provider directory, PAS provider directory, self-direction provider directory",
      name: "Personal Accounting Services, Inc.",
    },
  },
} as const;

export type OrganizationKey = keyof typeof ORG_META;
